/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pin-map': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 6a3 3 0 100 6 3 3 0 000-6zm0 1.2a1.8 1.8 0 110 3.6 1.8 1.8 0 010-3.6zM5.05 4.052a7.01 7.01 0 000 9.906l3.395 3.397a2.197 2.197 0 003.111 0l3.394-3.397a7.01 7.01 0 000-9.906 6.996 6.996 0 00-9.9 0zm9.051.849a5.807 5.807 0 010 8.208l-3.394 3.397a1 1 0 01-1.413 0L5.9 13.11a5.807 5.807 0 010-8.208 5.796 5.796 0 017.992-.2l.21.2z" _fill="#01B9CA" fill-rule="evenodd"/>'
  }
})
